import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.services";
import { TOAST_SUCCESS } from "../../config/common";

export const getContactUsListApiCall = createAsyncThunk("contactUsList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: contactUsList } = await API.getContactUsListAPI(submitData);
        dispatch(setLoader(false))
        return contactUsList;
    } catch (error) {
        throw error;
    }
});

export const editContactUsDataApiCall = createAsyncThunk("editContactUsData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editContactUsData, code, message } = await API.editContactUsDetailsAPI(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editContactUsData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    contactUsList: {
        data: [],
        error: null,
    },
    editContactUsData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const contactUsSlice = createSlice({
    name: "Contact Us",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getContactUsListApiCall.fulfilled, (state, action) => {
                state.contactUsList.data = action.payload;
            })
            .addCase(getContactUsListApiCall.rejected, (state, action) => {
                state.contactUsList.error = action.error.message;
            })
            .addCase(editContactUsDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editContactUsData.data = data;
                state.editContactUsData.message = message;
                state.editContactUsData.code = code;
            })
            .addCase(editContactUsDataApiCall.rejected, (state, action) => {
                state.editContactUsData.error = action.error.message;
            });
    },
});

export default contactUsSlice.reducer;